/* Cliki Snake: the CLIKEA GAMING mini game (Claude Code, 2026-10-09).
   Opens from [data-clg-arcade] (Cliki bubble, side menu). Scores stay on the
   device (top 5); an online ranking needs a backend (ERP), not a public key. */
(() => {
  const dialog = document.querySelector('[data-clg-arcade-dialog]');
  if (!dialog) return;

  const BEST_KEY = 'clg:arcade-best';
  const TOP_KEY = 'clg:arcade-top';
  const COLS = 18;
  const ROWS = 18;
  const FOODS = [
    { label: 'RAM', points: 10, color: '#22d3ee', weight: 6 },
    { label: 'SSD', points: 15, color: '#4ade80', weight: 3 },
    { label: 'GPU', points: 25, color: '#f472b6', weight: 1 },
  ];
  const target = Number(dialog.dataset.target) || 100;
  const prizeCode = (() => {
    try { return atob(dialog.dataset.prize || ''); } catch { return ''; }
  })();

  const $ = (selector) => dialog.querySelector(selector);
  const canvas = $('[data-arc-canvas]');
  const stage = $('[data-arc-stage]');
  const ctx = canvas.getContext('2d');
  const screens = { start: $('[data-arc-start]'), over: $('[data-arc-over]'), ranking: $('[data-arc-ranking]') };
  const show = (name) => Object.entries(screens).forEach(([key, node]) => { node.hidden = key !== name; });
  const escapeHtml = (value) => String(value ?? '').replace(/[&<>"']/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char]);
  const readBest = () => { try { return Number(localStorage.getItem(BEST_KEY)) || 0; } catch { return 0; } };
  const writeBest = (value) => { try { localStorage.setItem(BEST_KEY, String(value)); } catch { /* storage unavailable */ } };
  const readTop = () => {
    try {
      const rows = JSON.parse(localStorage.getItem(TOP_KEY) || '[]');
      return Array.isArray(rows) ? rows.filter((row) => Number.isFinite(row?.points)).slice(0, 5) : [];
    } catch {
      return [];
    }
  };
  const saveTop = (points, reached) => {
    if (points <= 0) return;
    const rows = [...readTop(), { points, level: reached, date: new Date().toISOString().slice(0, 10) }];
    rows.sort((a, b) => b.points - a.points);
    try { localStorage.setItem(TOP_KEY, JSON.stringify(rows.slice(0, 5))); } catch { /* storage unavailable */ }
  };

  const cliki = new Image();
  cliki.src = dialog.dataset.cliki;

  let snake;
  let direction;
  let queued;
  let food;
  let score;
  let level;
  let timer = null;
  let running = false;
  let floaters = [];
  let cell = 24;

  const setHud = () => {
    $('[data-arc-score]').textContent = String(score);
    $('[data-arc-level]').textContent = String(level);
    $('[data-arc-best]').textContent = String(Math.max(readBest(), score));
  };

  const resize = () => {
    // inner box: minus the stage padding (12px each side) and the canvas border
    const width = stage.clientWidth - 28;
    const height = stage.clientHeight - 28;
    const size = Math.floor(Math.max(200, Math.min(width, height > 0 ? height : width, 520)));
    const ratio = window.devicePixelRatio || 1;
    canvas.style.width = `${size}px`;
    canvas.style.height = `${size}px`;
    canvas.width = Math.round(size * ratio);
    canvas.height = Math.round(size * ratio);
    ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
    cell = size / COLS;
    draw();
  };

  const pickFood = () => {
    const total = FOODS.reduce((sum, entry) => sum + entry.weight, 0);
    let roll = Math.random() * total;
    const type = FOODS.find((entry) => (roll -= entry.weight) < 0) || FOODS[0];
    let spot;
    do {
      spot = { x: Math.floor(Math.random() * COLS), y: Math.floor(Math.random() * ROWS) };
    } while (snake.some((part) => part.x === spot.x && part.y === spot.y));
    return { ...spot, type };
  };

  const speed = () => Math.max(70, 150 - (level - 1) * 12);

  const roundRect = (x, y, w, h, r) => {
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + w, y, x + w, y + h, r);
    ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r);
    ctx.arcTo(x, y, x + w, y, r);
    ctx.closePath();
  };

  function draw() {
    const size = cell * COLS;
    ctx.fillStyle = '#0e0822';
    ctx.fillRect(0, 0, size, size);
    ctx.strokeStyle = 'rgba(167, 139, 250, 0.08)';
    ctx.lineWidth = 1;
    for (let i = 1; i < COLS; i += 1) {
      ctx.beginPath();
      ctx.moveTo(i * cell, 0);
      ctx.lineTo(i * cell, size);
      ctx.moveTo(0, i * cell);
      ctx.lineTo(size, i * cell);
      ctx.stroke();
    }
    if (!snake) return;
    if (food) {
      ctx.save();
      ctx.shadowColor = food.type.color;
      ctx.shadowBlur = 14;
      ctx.fillStyle = food.type.color;
      roundRect(food.x * cell + 2, food.y * cell + 3, cell - 4, cell - 6, 4);
      ctx.fill();
      ctx.restore();
      ctx.fillStyle = '#0e0822';
      ctx.font = `800 ${Math.max(7, cell * 0.32)}px DM Sans, sans-serif`;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(food.type.label, food.x * cell + cell / 2, food.y * cell + cell / 2);
    }
    snake.forEach((part, index) => {
      if (index === 0) return;
      const t = index / snake.length;
      ctx.fillStyle = `rgba(${Math.round(168 - 44 * t)}, ${Math.round(85 - 27 * t)}, 247, ${1 - t * 0.45})`;
      roundRect(part.x * cell + 2, part.y * cell + 2, cell - 4, cell - 4, cell * 0.3);
      ctx.fill();
    });
    const head = snake[0];
    const headSize = cell * 1.45;
    if (cliki.complete && cliki.naturalWidth) {
      ctx.save();
      ctx.shadowColor = '#a855f7';
      ctx.shadowBlur = 12;
      ctx.drawImage(cliki, head.x * cell + cell / 2 - headSize / 2, head.y * cell + cell / 2 - headSize / 2, headSize, headSize);
      ctx.restore();
    } else {
      ctx.fillStyle = '#a855f7';
      roundRect(head.x * cell + 1, head.y * cell + 1, cell - 2, cell - 2, cell * 0.35);
      ctx.fill();
    }
    floaters = floaters.filter((entry) => entry.life > 0);
    floaters.forEach((entry) => {
      ctx.globalAlpha = entry.life / 20;
      ctx.fillStyle = entry.color;
      ctx.font = `800 ${Math.max(10, cell * 0.55)}px DM Sans, sans-serif`;
      ctx.fillText(entry.text, entry.x, entry.y);
      entry.y -= 1.2;
      entry.life -= 1;
      ctx.globalAlpha = 1;
    });
  }

  function step() {
    direction = queued;
    const head = { x: snake[0].x + direction.x, y: snake[0].y + direction.y };
    const hitWall = head.x < 0 || head.y < 0 || head.x >= COLS || head.y >= ROWS;
    const hitSelf = snake.some((part) => part.x === head.x && part.y === head.y);
    if (hitWall || hitSelf) return gameOver();
    snake.unshift(head);
    if (food && head.x === food.x && head.y === food.y) {
      score += food.type.points;
      floaters.push({ text: `+${food.type.points}`, color: food.type.color, x: head.x * cell + cell / 2, y: head.y * cell, life: 20 });
      const nextLevel = 1 + Math.floor(score / 60);
      if (nextLevel !== level) level = nextLevel;
      food = pickFood();
      if (navigator.vibrate) navigator.vibrate(15);
    } else {
      snake.pop();
    }
    setHud();
    draw();
    timer = setTimeout(step, speed());
  }

  function start() {
    clearTimeout(timer);
    snake = [{ x: 8, y: 9 }, { x: 7, y: 9 }, { x: 6, y: 9 }];
    direction = { x: 1, y: 0 };
    queued = direction;
    score = 0;
    level = 1;
    floaters = [];
    food = pickFood();
    running = true;
    show(null);
    setHud();
    draw();
    timer = setTimeout(step, speed());
  }

  function gameOver() {
    running = false;
    clearTimeout(timer);
    if (score > readBest()) writeBest(score);
    saveTop(score, level);
    setHud();
    $('[data-arc-final]').textContent = String(score);
    const won = score >= target && prizeCode;
    $('[data-arc-over-title]').textContent = won ? '¡Increíble, ganaste!' : '¡Fin del juego!';
    $('[data-arc-prize]').hidden = !won;
    $('[data-arc-hint]').hidden = Boolean(won);
    if (won) $('[data-arc-code]').textContent = prizeCode;
    $('[data-arc-msg]').textContent = '';
    show('over');
  }

  const turn = (name) => {
    if (!running) return;
    const map = { up: { x: 0, y: -1 }, down: { x: 0, y: 1 }, left: { x: -1, y: 0 }, right: { x: 1, y: 0 } };
    const next = map[name];
    if (!next) return;
    if (next.x === -direction.x && next.y === -direction.y) return;
    queued = next;
  };

  // ---------- personal ranking ----------
  function loadRanking() {
    const rows = readTop();
    $('[data-arc-ranking-list]').innerHTML = rows.length
      ? rows.map((row) => `<li><span>Nivel ${Number(row.level) || 1} · ${escapeHtml(row.date || '')}</span><b>${row.points} pts</b></li>`).join('')
      : '<li><span>Aún no tienes partidas. ¡Juega la primera!</span></li>';
  }

  // ---------- events ----------
  const open = () => {
    if (!dialog.open) dialog.showModal();
    show('start');
    requestAnimationFrame(resize);
    setHud();
  };
  const close = () => {
    clearTimeout(timer);
    running = false;
    dialog.close();
  };
  score = 0;
  level = 1;

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-clg-arcade]');
    if (!trigger) return;
    event.preventDefault();
    const drawer = document.querySelector('header-drawer');
    const openMenu = drawer?.querySelector('details[open]');
    if (openMenu && typeof drawer.closeMenuDrawer === 'function') drawer.closeMenuDrawer(event, openMenu.querySelector('summary'));
    const bubble = document.getElementById('clg-helper-bubble');
    if (bubble) bubble.hidden = true;
    open();
  });
  dialog.addEventListener('click', async (event) => {
    if (event.target.closest('[data-arc-close]')) return close();
    if (event.target.closest('[data-arc-play]')) return start();
    if (event.target.closest('[data-arc-show-ranking]')) {
      show('ranking');
      return loadRanking();
    }
    const dir = event.target.closest('[data-arc-dir]');
    if (dir) return turn(dir.dataset.arcDir);
    const msg = $('[data-arc-msg]');
    if (event.target.closest('[data-arc-copy]')) {
      try {
        await navigator.clipboard.writeText(prizeCode);
        msg.textContent = 'Código copiado.';
      } catch {
        msg.textContent = `Tu código: ${prizeCode}`;
      }
      return;
    }
    if (event.target.closest('[data-arc-apply]')) {
      try {
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: prizeCode }),
        });
        if (!response.ok) throw new Error();
        const cart = await response.json();
        const entry = (cart.discount_codes || []).find((code) => code.code.toUpperCase() === prizeCode.toUpperCase());
        msg.textContent = entry?.applicable
          ? 'Listo: el cupón quedó aplicado a tu bolsa.'
          : 'Cupón guardado en tu bolsa: se aplica al agregar productos.';
      } catch {
        msg.textContent = 'No pude aplicarlo; cópialo y úsalo al pagar.';
      }
    }
  });
  document.addEventListener('keydown', (event) => {
    if (!dialog.open) return;
    const keys = { ArrowUp: 'up', ArrowDown: 'down', ArrowLeft: 'left', ArrowRight: 'right', w: 'up', s: 'down', a: 'left', d: 'right' };
    const name = keys[event.key];
    if (name && running) {
      event.preventDefault();
      turn(name);
    }
  });
  let touch = null;
  stage.addEventListener('touchstart', (event) => {
    const point = event.touches[0];
    touch = { x: point.clientX, y: point.clientY };
  }, { passive: true });
  stage.addEventListener('touchmove', (event) => {
    if (running) event.preventDefault();
  }, { passive: false });
  stage.addEventListener('touchend', (event) => {
    if (!touch) return;
    const point = event.changedTouches[0];
    const dx = point.clientX - touch.x;
    const dy = point.clientY - touch.y;
    touch = null;
    if (Math.max(Math.abs(dx), Math.abs(dy)) < 18) return;
    turn(Math.abs(dx) > Math.abs(dy) ? (dx > 0 ? 'right' : 'left') : (dy > 0 ? 'down' : 'up'));
  });
  window.addEventListener('resize', () => { if (dialog.open) resize(); });
  document.addEventListener('visibilitychange', () => {
    if (document.hidden && running) gameOver();
  });
  dialog.addEventListener('close', () => {
    clearTimeout(timer);
    running = false;
  });
})();
